import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-72806ab6"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["aria-label"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("button", {
    ref: "scrollToTopButton",
    class: "scroll-to-top",
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.scrollToTop && $setup.scrollToTop(...args))),
    "aria-label": _ctx.$t('Scroll to top')
  }, [
    _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-chevron-up" })
  ], 8, _hoisted_1))
}